import {
  InfoCircleOutlined,
  EyeOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Button, Row, Col, Tag } from "antd";
import momentTZ from "moment-timezone";
import { shallowEqual, useSelector } from "react-redux";
import { momentDateTimeFormat } from "shared/plugins/localization";
import {
  formatPersonName,
  formatPhoneNumber,
} from "shared/plugins/string-helper";
import { selectCurrentBranch } from "states/branch/branch.slice";
import { OrderModel } from "states/order/order.models";
import { OrderStatusTag } from "./order-status-tag";

export interface IOrderDetailInfoProps {
  order: OrderModel;
  onViewOrAdd?: () => void;
}

export function OrderDetailInfo(props: IOrderDetailInfoProps) {
  const { order, onViewOrAdd } = props;
  const currentBranch = useSelector(selectCurrentBranch, shallowEqual);

  return (
    <>
      <div className="mb-2 p-2 bg-white">
        <div className="mb-4">
          <InfoCircleOutlined /> <b>Thông tin</b>{" "}
          <Button type="link" onClick={onViewOrAdd} icon={<EyeOutlined />}>
            Lịch sử
          </Button>
        </div>
        <Row
          gutter={[8, 8]}
          justify="space-between"
          align="middle"
          className="mb-2"
        >
          <Col>Mã đơn hàng:</Col>{" "}
          <Col>
            <b>{order.orderNumber}</b>
          </Col>
        </Row>
        {order.couponCode && (
          <Row
            gutter={[8, 8]}
            justify="space-between"
            align="middle"
            className="mb-2"
          >
            <Col>Coupon:</Col>{" "}
            <Col>
              <Tag color="#eb2f96">
                {" "}
                <b>{order.couponCode}</b>
              </Tag>
            </Col>
          </Row>
        )}
        {order.cartPromotionName && (
          <Row
            gutter={[8, 8]}
            justify="space-between"
            align="middle"
            className="mb-2"
          >
            <Col>Khuyến mãi:</Col>{" "}
            <Col>
              <Tag color="#eb2f96">
                {" "}
                <b>{order.cartPromotionName}</b>
              </Tag>
            </Col>
          </Row>
        )}
        <Row
          gutter={[8, 8]}
          justify="space-between"
          align="middle"
          className="mb-2"
        >
          <Col>Ngày tạo:</Col>
          <Col>
            {momentTZ
              .tz(order.creationTime, currentBranch?.ianaTimeZone)
              .format(momentDateTimeFormat())}
          </Col>
        </Row>
        <Row
          gutter={[8, 8]}
          justify="space-between"
          align="middle"
          className="mb-2"
        >
          <Col>Người tạo:</Col>
          <Col>
            {order.staff
              ? `NV: ${formatPersonName(
                  order.staff.firstName,
                  order.staff.lastName
                )}`
              : formatPersonName(
                  order.customer?.firstName,
                  order.customer?.lastName
                )}
          </Col>
        </Row>
        <Row
          gutter={[8, 8]}
          justify="space-between"
          align="middle"
          className="mb-2"
        >
          <Col>Chi nhánh:</Col> <Col>{order.branch?.name}</Col>
        </Row>
        <Row
          gutter={[8, 8]}
          justify="space-between"
          align="middle"
          className="mb-2"
        >
          <Col>Kho:</Col> <Col>{order.wareHouse?.name}</Col>
        </Row>
        <Row gutter={[8, 8]} justify="space-between" align="middle">
          <Col>Trạng thái:</Col>{" "}
          <Col>
            <OrderStatusTag status={order.status} />
          </Col>
        </Row>
      </div>
      <div className="mb-2 p-2 bg-white">
        <div className="mb-2">
          <UserOutlined /> <b>Khách hàng</b>
        </div>
        <Row
          gutter={[8, 8]}
          justify="space-between"
          align="middle"
          className="mb-2"
        >
          <Col>Họ tên:</Col>
          <Col>
            {formatPersonName(
              order.customer?.firstName,
              order.customer?.lastName
            )}
          </Col>
        </Row>
        <Row
          gutter={[8, 8]}
          justify="space-between"
          align="middle"
          className="mb-2"
        >
          <Col>Số điện thoại:</Col>
          <Col>{formatPhoneNumber(order.customer?.phoneNumber)}</Col>
        </Row>
        <Row gutter={[8, 8]} justify="space-between" align="middle">
          <Col>Email:</Col>
          <Col>{order.customer?.email}</Col>
        </Row>
      </div>
    </>
  );
}
